import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import api from '@tutorbot/directory-api';
import Scroll from 'react-scroll';
import { Table, Popconfirm } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import { IoIosAdd } from 'react-icons/io';
import { EditorContext } from '../../../hoc/Editor';
import { LocalizationContext } from '../../../hoc/Localization';
import Button from '../../Button';
import ScheduleModal from '../../InlineEditor/ScheduleModal';
import Noschedule from '../../NoSchedule';
import styles from './styles.less';

function sortByOrder(data, order) {
  const res = [];
  order.map(item =>
    data.map(i => {
      if (item === (typeof i === 'object' ? i.title : i)) {
        res.push(i);
      }
      return 0;
    }),
  );
  return res;
}

const Schedule = ({
  schedules,
  setRegister,
  selectedSchedule,
  setSelectedSchedule,
  allSchedules,
}) => {
  const { t, locale } = useContext(LocalizationContext);
  const { editMode, updateContent, edited } = React.useContext(EditorContext);

  const [newSchedule, setNewSchedule] = React.useState(false);
  const [modalVisible, setModalVisible] = React.useState(false);
  const [fetchedDaytimes, setFetchedDaytimes] = React.useState([]);
  const [fetchedWeekDays, setFetchedWeekDays] = React.useState([]);
  const [currentSchedules, setCurrentSchedules] = React.useState([]);

  moment.locale(locale === 'hy' ? 'hy-am' : locale);
  React.useEffect(() => {
    if (edited.schedules) {
      edited.schedules.sort((a, b) => (new Date(a.start_date) > new Date(b.start_date) ? 1 : -1));
      setCurrentSchedules(edited.schedules.filter(word => word.start_date) || []);
    }
  }, [edited.schedules]);

  React.useEffect(() => {
    (async () => {
      setFetchedDaytimes(await api().dayTimes.all());
      setFetchedWeekDays(await api().weekDays.all());
    })();
  }, []);

  const { scroller } = Scroll;
  const daytimeOrder = ['Morning', 'Afternoon', 'Evening'];
  const weekdayOrder = [
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday',
  ];

  /* eslint-disable */

  let data = currentSchedules.map((o, key) => {
    const weekend =
      o.weekdays &&
      o.weekdays.filter(
        i => i && i.id === '5b9a5d6dffe5430011245b22' && i.id === '5b9a5d78ffe5430011245b23',
      );

    return {
      key,
      deleted: o.deleted,
      startDate: o.start_date
        ? o.end_date
          ? `${moment(o.start_date).format('ll')} - ${moment(o.end_date).format('ll')}`
          : moment(o.start_date).format('ll')
        : '-',
      duration: o.duration_weeks
        ? o.duration_type === 'week'
          ? o.duration_weeks !== 1
            ? `${o.duration_weeks} ${t('course.details.duration.weeks')}`
            : `1 ${t('search.duration.week')}`
          : o.duration_weeks !== 1
            ? `${o.duration_weeks} ${t('course.details.countdown.days')}`
            : `1 ${t('course.details.countdown.day')}`
        : '-',

      weekdays: o.custom_weekdays
        ? o.custom_weekdays
        : o.weekdays && !!o.weekdays.length
          ? o.weekdays.length !== 7
            ? !weekend.length && o.weekdays.length === 5
              ? t('course.details.schedule.workDays')
              : sortByOrder(
                o.weekdays.filter(weekday => !!weekday).map(weekday => weekday.title),
                weekdayOrder,
              )
                .map(title => t(`course.schedule.days.${title.toLowerCase()}`).substr(0, 3))
                .join(', ')
            : t('course.details.schedule.everyDay')
          : '-',
      daytimes: o.custom_daytime
        ? o.custom_daytime && o.custom_daytime_end
          ? `${moment(o.custom_daytime).format('HH:mm')} - ${moment(o.custom_daytime_end).format(
            'HH:mm',
          )}`
          : moment(o.custom_daytime).format('HH:mm')
        : o.daytimes && !!o.daytimes.length
          ? sortByOrder(
            o.daytimes.filter(daytime => !!daytime).map(daytime => daytime.title),
            daytimeOrder,
          )
            .map(daytime => t(`details.course.${daytime.toLowerCase()}`))
            .join(', ')
          : '-',
      availableSeats: o.available_seats
        ? `${o.available_seats} ${t('course.schedule.seats')} `
        : '-',
    };
  });

  /* eslint-enable */

  const columns = [
    {
      title: t('course.details.content.start_date'),
      dataIndex: 'startDate',
    },
    {
      title: t('search.duration.title'),
      dataIndex: 'duration',
    },
    {
      title: t('course.schedule.weekdays'),
      dataIndex: 'weekdays',
    },
    {
      title: t('course.details.content.daytime'),
      dataIndex: 'daytimes',
    },
    {
      title: t('course.details.availableseats'),
      dataIndex: 'availableSeats',
    },
    {
      title: '',
      dataIndex: 'delete',
    },
  ];

  const handleScheduleSelect = key => {
    if (!editMode) {
      setTimeout(() => {
        scroller.scrollTo('register', {
          duration: 500,
          delay: 100,
          smooth: true,
          offset: -100,
        });
      });
    } else {
      setModalVisible(true);
    }

    setSelectedSchedule(currentSchedules[key]);
  };

  const dataSource = [];

  if (data) {
    data.forEach((schedule, index) => {
      if (schedule.deleted) {
        return false;
      }

      const res = schedule;
      // eslint-disable-next-line
      for (const record of Object.keys(schedule)) {
        const title = columns.filter(col => col.dataIndex === record)[0];
        if (title) {
          res[record] = (
            <div className={styles.tableRecord}>
              <span>{title.title}</span>
              {schedule[record]}
            </div>
          );
        }
      }
      if (editMode) {
        res.delete = (
          <div onClick={e => e.stopPropagation()} className={styles.pop}>
            <Popconfirm
              title={`${t('course.schedule.delete.message')}`}
              okText={`${t('addschool.confirm.yes')}`}
              cancelText={`${t('addschool.confirm.no')}`}
              onConfirm={e => {
                e.stopPropagation();
                const result = [...currentSchedules];
                result[index].deleted = true;
                updateContent({ ...edited, schedules: result });
              }}
            >
              <DeleteOutlined />
            </Popconfirm>
          </div>
        );
      }

      return dataSource.push(res);
    });
  }

  const rowSelection = {
    type: 'radio',
    selections: true,
    selectedRowKeys: [schedules.indexOf(selectedSchedule)],
    onSelect: e => {
      handleScheduleSelect(e.key);
    },
  };

  if (selectedSchedule !== null) {
    setRegister(true);
  } else {
    setRegister(false);
  }

  const scheduleIndex = allSchedules.indexOf(selectedSchedule);

  const noScheduleWarning = () => {
    if (currentSchedules.filter(it => it.deleted).length === currentSchedules.length) {
      return true;
    }
    return false;
  };

  return (
    <div id="schedule" className={styles.container}>
      {editMode && noScheduleWarning() ? (
        <Noschedule />
      ) : (
          <Table
            className={`formatted ${styles.table}`}
            style={{ width: '100%' }}
            rowSelection={rowSelection}
            columns={columns}
            dataSource={dataSource}
            pagination={false}
            onRow={e => ({
              onClick: () => {
                handleScheduleSelect(e.key);
              },
            })}
            rowClassName={(record, index) =>
              `${index === schedules.indexOf(selectedSchedule) ? `${styles.selected}` : null
              } schedule${index}`}
          />
        )}
      {editMode && modalVisible && (
        <ScheduleModal
          index={scheduleIndex}
          visible={modalVisible}
          newSchedule={newSchedule}
          key={selectedSchedule && selectedSchedule.id}
          schedule={selectedSchedule}
          setVisible={setModalVisible}
          setNewSchedule={setNewSchedule}
          setSelectedSchedule={setSelectedSchedule}
          fetchedDaytimes={sortByOrder(fetchedDaytimes, daytimeOrder)}
          fetchedWeekDays={sortByOrder(fetchedWeekDays, weekdayOrder)}
        />
      )}

      {editMode && (
        <div className={styles.addButtonContainer}>
          <Button
            type="primary"
            className={styles.addButton}
            onClick={() => {
              setModalVisible(true);
              setNewSchedule(true);
            }}
            data_gh="course_edit_addSchedule"
          >
            <IoIosAdd className={styles.addIcon} />
            {t('course.edit.schedule.add')}
          </Button>
        </div>
      )}
    </div>
  );
};

Schedule.propTypes = {
  allSchedules: PropTypes.array,
  schedules: PropTypes.array.isRequired,
  setRegister: PropTypes.func.isRequired,
  selectedSchedule: PropTypes.object,
  setSelectedSchedule: PropTypes.func.isRequired,
};

Schedule.defaultProps = {
  allSchedules: [],
  selectedSchedule: null,
};

export default Schedule;
